import { useQuery } from 'react-query';

import { QueryStateValue } from 'hooks/useQueryState';

import { getUuid as queryFn } from 'api/endPoints/getUuid';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetAccessToken = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getAccessToken', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.uuid) && (params.ssoType === 'AAD' || params.ssoType === 'OKTA'),
    });
};

export interface QueryParams {
    uuid: QueryStateValue;
    ssoType?: string;
}

interface QueryResponse {
    username: string;
}
